import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { sendLog } from '@profile-ui/shared-components';
import { FALLBACK_FLAGS } from '@profile-ui-mono/utilities/constants';

const useLdFlags = () => {
  const flags = useFlags();

  const memoizedFlags = useMemo(() => {
    // When Launch Darkly fails, useFlags returns an empty Proxy(Object)
    if (!Object.keys(flags).length) {
      const error = new Error('LD flags are empty object');
      sendLog(error, 'useLdFlags', 'LD flags are empty object');
      return FALLBACK_FLAGS;
    }
    
    return flags;
  }, [flags]);

  return memoizedFlags;
};

export default useLdFlags;
